import mmcAjax from '@/common/js/mmcAjax.js';

/** 项目验证 API 基础地址 */
const REVIEW_ROOT = APIBasePath + 'mmc/withdrawals';

export function getHospitalByProvince(provinceId) {
    const url = `${REVIEW_ROOT}/hospital/list/${provinceId}`;
    return mmcAjax({ method: 'get', url });
}

export function getAidedInfo(uuid) {
    const url = `${REVIEW_ROOT}/patient/info/${uuid}`;
    return mmcAjax({ method: 'get', url });
}

export function submitAidedInfo(params) {
    const url = `${REVIEW_ROOT}/patient/set`;
    return mmcAjax({ method: 'post', url, data: params });
}

export function getPayeeInfo(uuid) {
    const url = `${REVIEW_ROOT}/payee/info/${uuid}`;
    return mmcAjax({ method: 'get', url });
}

export function submitPayeeInfo(params) {
    const url = `${REVIEW_ROOT}/payee/set`;
    return mmcAjax({ method: 'post', url, data: params });
}

export function getBankList() {
    const url = `${REVIEW_ROOT}/bank/list`;
    return mmcAjax({ method: 'get', url });
}
